import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { AppPaths } from '../enums/app-paths.enum';

export interface MessageNavigationOptions {
  preserveQueryParams?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MessageNavigationService {
  constructor(private router: Router) {}

  goToMessage(message: string, options: MessageNavigationOptions = {}): void {
    const navigationExtras: NavigationExtras = {
      state: { message },
    };

    if (options.preserveQueryParams) {
      navigationExtras.queryParamsHandling = 'preserve';
    }

    this.router.navigate([AppPaths.MESSAGE], navigationExtras);
  }
}
